<div class="loader" *ngIf="isGroupLoading">
  <app-three-dots-blinking></app-three-dots-blinking>
</div>
<div class="container" *ngIf="!isGroupLoading">
  <div class="header-wrapper">
    <div class="header">
      <h2>{{'reporting.PERCENT_CERTIFIED_ON' | transloco}} {{moduleName}}</h2>
      <label>{{'reporting.SHOWING' | transloco}} {{activeReportGroup}}</label>
    </div>
    <div class="export-list">
      {{'reporting.EXPORT_LEARNER_LIST' | transloco}} <img src="/assets/icons/download-01.svg">
    </div>
  </div>
  <div class="labels">
    <ng-container *ngIf="!showBreadCrums">
      <div class="name" [class.active]="group.active" (click)="setGroup(group)" *ngFor="let group of reportGroups">
        {{group.reportGroupName}}</div>
    </ng-container>
    <ng-container *ngIf="showBreadCrums">
      <mat-select [(value)]="selectedReportGroup">
        <mat-option *ngFor="let group of reportGroups" [value]="group" (click)="resetGroup(group.reportGroupUuid)">
          {{ group.reportGroupName }}
        </mat-option>
      </mat-select>
      <div class="vertical-line"></div>
      <div class="breadcrums">
        <div class="name" (click)="setGroup(selectedReportGroup)">{{selectedReportGroup.reportGroupName}} <img
            src="/assets/icons/arrow/chevron-right-grey.svg"></div>
        <div class="name" [class.last-name]="last"
          *ngFor="let group of activeReportGroups[0].nestedGroups;  let last = last" (click)="pruneNestedGroup(group)">
          {{group.reportGroupName}} <img *ngIf="!last" src="/assets/icons/arrow/chevron-right-grey.svg"></div>
      </div>
    </ng-container>
  </div>
  <div class="statistics" [class.hidden]="isPreCalLoading || !isReportGroupDataAvailable">
    <div class="left-section">
      <div class="percentage">
        <img src="/assets/icons/yellow-circle-0.6.svg">
        <p>{{precalData?.progressOverview?.notStarted?.percentage}} {{'reporting.PERCENT_NOT_STARTED' | transloco}}</p>
      </div>
      <div class="percentage">
        <img src="/assets/icons/blue-circle-0.6.svg">
        <p>{{precalData?.progressOverview?.inProgress?.percentage}} {{'reporting.PERCENT_IN_PROGRESS' | transloco}}</p>
      </div>
      <div class="percentage">
        <img src="/assets/icons/green-circle.svg">
        <p>{{precalData?.progressOverview?.certified?.percentage}} {{'reporting.PERCENT_CERTIFIED' | transloco}}</p>
      </div>

    </div>
    <div class="right-section">
      <div class="number">
        {{precalData?.progressOverview?.certified?.numberOfMembers}} 
        <span>{{ precalData?.progressOverview?.certified?.numberOfMembers === 1 ? ('reporting.USER_CERTIFIED' | transloco) : ('reporting.USERS_CERTIFIED' | transloco) }}</span>
      </div>
      <div class="number">
        {{ formatNumber(precalData?.avgAttemptsToCertify) }} <span>{{'reporting.Avg_ATTEMPTS_CERTIFY' | transloco}}</span>
      </div>
      <div class="number">
        {{precalData?.totalScoredAttemptCount}} <span>{{'reporting.TOTAL_ATTEMPTS' | transloco}}</span>
      </div>

    </div>
  </div>

  <div #chartContainer class="chart-container">
    <div class="loader" *ngIf="isPreCalLoading && isReportGroupDataAvailable">
      <app-three-dots-blinking></app-three-dots-blinking>
    </div>
  </div>
  <div *ngIf="noDataMsg" class="error">{{noDataMsg}}</div>
  <div *ngIf="shouldShowGroup()" class="group">* {{'reporting.ASTERICK_GROUP' | transloco}}</div>
</div>